import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-simple-input-number',
    templateUrl: './simple-input-number.component.html',
    styleUrls: ['./simple-input-number.component.scss'],
    standalone: false
})
export class SimpleInputNumberComponent implements OnInit {
  @Input() data: number;
  @Input() disabledFlag: boolean;
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Output() focusOut: EventEmitter<number> = new EventEmitter<number>();
  @Output() keyUp: EventEmitter<number> = new EventEmitter<number>();
  @Input() required: boolean = false;
  @Input() maxlength: number = 524288;

  tempValue: any;
  message: string = "";
  containerClass: string = "";

  constructor() {}

  ngOnInit() {
  }

  onFocusOut() {
    this.containerClass = "";
    this.focusOut.emit( this.data );
    this.message = "";
  }
  onKeyUp() {
    this.containerClass = "";
    this.focusOut.emit( this.data );
    this.message = "";
  }

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - parseInt(i)).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      //console.log(e)
    }
  };


  startEdit() {
    this.containerClass = "active";
    this.tempValue = this.data;
  }

  undo() {
    this.data = this.tempValue;
  }
}

